
import { useCallback } from 'react';
import { useSweepstakesForm } from './useSweepstakesForm';
import { useSweepstakesData, Sweepstakes } from './useSweepstakesData';
import { useSweepstakesEntries } from './useSweepstakesEntries';
import { useSweepstakesSubmit } from './sweepstakes/useSweepstakesSubmit';
import { useSweepstakesDelete } from './sweepstakes/useSweepstakesDelete';
import { useSweepstakesDraw } from './sweepstakes/useSweepstakesDraw';

export const useSweepstakesManagement = () => {
  // Get sweepstakes data and entries data
  const { sweepstakes, loading, rewards, fetchSweepstakes } = useSweepstakesData();
  const { entries, loadingEntries, selectedSweepstakesId, fetchEntries } = useSweepstakesEntries();

  const {
    isAddingNew,
    setIsAddingNew,
    editingSweepstakes,
    formValues,
    handleInputChange,
    resetForm,
    startEdit
  } = useSweepstakesForm();

  // Use our extracted hooks
  const { handleSubmit, isSubmitting } = useSweepstakesSubmit(
    formValues, 
    editingSweepstakes, 
    resetForm, 
    fetchSweepstakes
  );
  
  const { handleDelete } = useSweepstakesDelete(fetchSweepstakes);
  const { runManualDraw } = useSweepstakesDraw(fetchSweepstakes);
  
  const handleEdit = useCallback((sweepstake: Sweepstakes) => {
    startEdit(sweepstake);
  }, [startEdit]);

  return {
    sweepstakes,
    loading,
    rewards,
    isAddingNew,
    setIsAddingNew,
    editingSweepstakes,
    formValues,
    isSubmitting,
    handleInputChange,
    handleSubmit,
    resetForm,
    handleEdit,
    handleDelete,
    runManualDraw,
    entries,
    loadingEntries,
    fetchEntries,
    selectedSweepstakesId
  };
};
